<template>
  <div id="app">
    <SwitchLocale />
    <router-view></router-view>
  </div>
</template>

<script>

import SwitchLocale from "./components/SwitchLocale"

export default {
  name: 'app',
  components: {
        SwitchLocale
    },
  data:()=>({
  }),
  methods: {
    
  }
  
}
</script>